"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var RemoveDocument = function (_a) {
    var onClick = _a.onClick;
    return (react_1.default.createElement("button", { className: styles_module_scss_1.default.removeButton, onClick: onClick },
        react_1.default.createElement("img", { src: "/img/icons/doc-status/remove.svg", alt: "remove" })));
};
exports.default = RemoveDocument;
